import PropTypes from 'prop-types'
import unit from './unit'

const propTypes = PropTypes.arrayOf(unit)

export default propTypes
